import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=5bb6f09b&scoped=true&"
import script from "./InvoiceList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceList.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=5bb6f09b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6f09b",
  null
  
)

export default component.exports